import { render } from "./UclMatchday.vue?vue&type=template&id=4afe6170"
import script from "./UclMatchday.vue?vue&type=script&lang=js"
export * from "./UclMatchday.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__